import React from "react";

export function MovingWebsite() {

    return (
      <>
        <div className="col">
            <div className="under-construction-box center">
                I am currently changing the website to use a framework instead of WordPress. Due to this,
                most of the content is not visible right now (January 2026). I will gradually re-upload the contents.
            </div>
        </div>
      </>
    );
  }
  